module.exports = __webpack_public_path__ + "img/home_icon_wodekaquan.17ddc0a3.svg";